import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'

// import BootstrapVue
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import Vuelidate
import Vuelidate from 'vuelidate'

// import vue-snack
import VueSnackbar from 'vue-snack'
import 'vue-snack/dist/vue-snack.min.css'

// import FontAwesome
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faBars,
  faCheckCircle,
  faPlus,
  faBell,
  faHome,
  faEllipsisH,
  faEllipsisV,
  faUserPlus,
  faSignOutAlt,
  faInbox,
  faExclamation,
  faArrowDown,
  faSun,
  faIdCard,
  faCalendarDay,
  faClock,
  faUser,
  faUserFriends,
  faTimes,
  faCircle as fasCircle
} from '@fortawesome/free-solid-svg-icons'
import {faEdit, faTrashAlt, faCircle as farCircle} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

// use BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// use Vuelidate
Vue.use(Vuelidate)
// use FirestorePlugin
Vue.use(firestorePlugin)
// use vue-snack
Vue.use(VueSnackbar)

// initialize Firebase
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCUZMwQTIziv5j2fOg27aEM7dTQDJxXQXE",
  authDomain: "stuff-to-do-175b9.firebaseapp.com",
  databaseURL: "https://stuff-to-do-175b9.firebaseio.com",
  projectId: "stuff-to-do-175b9",
  storageBucket: "stuff-to-do-175b9.appspot.com",
  messagingSenderId: "862577816626",
  appId: "1:862577816626:web:b14bc3ea23bd6315cdb82b",
  measurementId: "G-2TY0C2HPJ7"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth()
const db = firebase.firestore()
const storage = firebase.storage()
export { auth, db, storage }
// firebase.analytics();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  })
};

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

// use FontAwesome
library.add(faBars, faCheckCircle, faPlus, faBell, faHome, faEllipsisH, faEllipsisV, faUserPlus, faSignOutAlt, faEdit,
  faTrashAlt, fasCircle, faInbox, faExclamation, faArrowDown, faSun, faIdCard, faCalendarDay, faIdCard, faClock, faUser, faUserFriends, faTimes, farCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
